<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />

      <v-spacer></v-spacer>
      <MgmtButtons
        :view="view"
        :acl="acl"
        :system="item.system"
        @createItem="createItem"
        @deleteItem="deleteItem"
        @cloneItem="cloneItem"
        @toView="toView"
        @toEdit="toEdit"
        :clone="true"
        :templates="templates"
      />
      </v-row>
      <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <v-tab href="#system" @click="activeTab = 'system'">Системные</v-tab>

        <v-tabs-items v-model="activeTab" touchless>
          <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="info">
            <v-row no-gutters class="tab-row">
              <v-col :cols="cols125">
                <v-card v-if="item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="red--text">Шаблон: {{ item.template_name }}</v-card-title>
                </v-card>

                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Информация</v-card-title>
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Номер:</th>
                        <td>{{ item.counter_view }}</td>
                      </tr>
                      <tr>
                        <th>Дата создания:</th>
                        <td>{{ item.date_created }}</td>
                      </tr>
                      <tr>
                        <th>Название:</th>
                        <td>{{ item.title }}</td>
                      </tr>
                      <tr>
                        <th>Стоимость:</th>
                        <td>{{ item.price|moneyFormatFilter }}</td>
                      </tr>
                      <tr>
                        <th>Плательщик:</th>
                        <td>{{ item.organization ? item.organization.name : '---' }}</td>
                      </tr>
                      <tr>
                        <th>Получатель:</th>
                        <td>{{ item.receiver_ru || '---' }}</td>
                      </tr>
                      <tr v-if="item.receiver === 'client'">
                        <th>Контрагент:</th>
                        <td>{{ item.client ? item.client.name : '---' }}</td>
                      </tr>
                      <tr v-if="item.receiver === 'unit'">
                        <th>Сотрудник:</th>
                        <td>{{ item.unit ? item.unit.name : '---' }}</td>
                      </tr>
                      <tr>
                        <th>Назначение платежа:</th>
                        <td>{{ item.payment_purpose ? item.payment_purpose.name : '---' }}</td>
                      </tr>

                    </table>
                  </v-card-text>
                </v-card>

                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">

                  <v-card-title class="primary--text">Описание</v-card-title>
                  <v-card-text>
                    <div v-if="item.text" class="task-text" v-html="item.text"></div>
                    <div v-else class="no-data">Нет данных</div>
                  </v-card-text>

                  <v-card-text v-if="item.tags && item.tags.length">
                    <v-chip-group
                      active-class="primary--text"
                      column
                    >
                      <v-chip
                        v-for="tag in item.tags"
                        :key="tag.id"
                        small
                      >
                        {{ tag.name }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>

                </v-card>

                <v-card v-if="!item.is_template && item.warehouse_balance && item.warehouse_balance.count" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Проводки по складу</v-card-title>
                    <WarehouseBalanceTable
                      :warehouse_balance="item.warehouse_balance"
                    />
                </v-card>

                <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Файлы</v-card-title>
                    <div class="redactor-field">
                      <MediaList
                        :id="item.id"
                        :acl="acl"
                        :view="view"
                        v-model="item.files"
                      ></MediaList>
                    </div>
                </v-card>
              </v-col>

              <v-col :cols="cols125">
                <v-card v-if="!isNew && !item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Статус</v-card-title>
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Текущий:</th>
                        <td>{{ item.status_ru }}</td>
                      </tr>
                      <tr>
                        <th>Изменить:</th>
                        <td><Status :items="item.available_statuses" @changeStatus="changeStatus" :pendingStatus="pendingStatus" /></td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>

                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Участники</v-card-title>
                  <v-card-text>

                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Автор:</th>
                        <td>
                          <div v-if="item.author">
                            <NeedWatch :check_time="item.check_this_persons[item.author.id]" />
                            <router-link :to="{ name: 'address_book_view', params: { id: item.author.userinfo.id }}">{{ item.author.name }}</router-link>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Постановщик:</th>
                        <td>
                          <div v-if="item.responsible">
                            <NeedWatch :check_time="item.check_this_persons[item.responsible.id]" />
                            <router-link :to="{ name: 'address_book_view', params: { id: item.responsible.userinfo.id }}">{{ item.responsible.name }}</router-link>
                          </div>
                         </td>
                      </tr>

                      <tr>
                        <th>Фин. директор:</th>
                        <td>
                          <div v-if="item.finance_director">
                            <NeedWatch :check_time="item.check_this_persons[item.finance_director.id]" />
                            <router-link :to="{ name: 'address_book_view', params: { id: item.finance_director.userinfo.id }}">{{ item.finance_director.name }}</router-link>
                          </div>
                         </td>
                      </tr>

                      <tr>
                        <th class="view-table-list">Бухгалтеры:</th>
                        <td>
                          <ul class="view-table-list">
                            <li v-for="accountant in item.accountants" :key="accountant.id">
                              <NeedWatch :check_time="item.check_this_persons[accountant.id]" />
                              <router-link :to="{ name: 'address_book_view', params: { id: accountant.userinfo.id }}">{{ accountant.name }}</router-link>
                            </li>
                          </ul>
                        </td>
                        <td valign="center" align="right">
                          <NewAccountants
                            class="mr-1"
                            v-if="[(item.assigned && item.assigned.id), (item.finance_director && item.finance_director.id)].includes(current_user.id)"
                            :id="item.id"
                            :url="urlObj"
                            :item="item"
                            @load="load"
                          />
                        </td>
                      </tr>

                      <tr>
                        <th>Исполнитель:</th>
                        <td>
                          <div v-if="item.assigned">
                            <NeedWatch :check_time="item.check_this_persons[item.assigned.id]" />
                              <router-link :to="{ name: 'address_book_view', params: { id: item.assigned.userinfo.id }}">{{ item.assigned.name }}</router-link>
                          </div>
                         </td>
                         <td align="right">
                            <NewAssigned
                              class="mr-1"
                              v-if="[(item.assigned && item.assigned.id), (item.finance_director && item.finance_director.id)].includes(current_user.id)"
                              :id="item.id"
                              :url="urlObj"
                              :item="item"
                              @load="load"
                            />
                         </td>
                      </tr>

                      <tr>
                        <th>Приоритет:</th>
                        <td>{{ item.priority_ru }}</td>
                        <td align="right">
                           <NewPriority
                             class="mr-1"
                             v-if="[(item.finance_director && item.finance_director.id)].includes(current_user.id)"
                             :id="item.id"
                             :url="urlObj"
                             :item="item"
                             @load="load"
                           />
                        </td>
                      </tr>
                      <tr>
                        <th>Выполнить к:</th>
                        <td>{{ item.date_end }}</td>
                        <td align="right">
                           <NewDateEnd
                             class="mr-1"
                             v-if="[(item.finance_director && item.finance_director.id)].includes(current_user.id)"
                             :id="item.id"
                             :url="urlObj"
                             :item="item"
                             @load="load"
                           />
                        </td>
                      </tr>

                      <tr>
                        <th class="view-table-list">Наблюдатели:</th>
                        <td>
                          <ul class="view-table-list">
                            <li v-for="watcher in item.watchers_list" :key="watcher.id">
                              <NeedWatch :check_time="item.check_this_persons[watcher.id]" />
                              <router-link :to="{ name: 'address_book_view', params: { id: watcher.userinfo.id }}">{{ watcher.name }}</router-link>
                            </li>
                          </ul>
                        </td>
                        <td valign="center" align="right">
                          <NewWatchers
                            class="mr-1"
                            v-if="[(item.assigned && item.assigned.id), (item.finance_director && item.finance_director.id)].includes(current_user.id)"
                            :id="item.id"
                            :url="urlObj"
                            :item="item"
                            @load="load"
                          />
                        </td>
                      </tr>

                    </table>
                  </v-card-text>
                </v-card>

                <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Комментарии</v-card-title>
                    <div class="redactor-field">
                      <Comments :url="urlObj" :id="id" :initialComments="item.comments" @setCheckThisOut="setCheckThisOut"></Comments>
                    </div>
                </v-card>

              </v-col>

            </v-row>
          </v-tab-item>

          <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="system">
            <v-row no-gutters class="tab-row">
              <v-col :cols="cols125">
                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-text>
                    <table class="view-table">
                      <tr>
                        <th>Создан:</th>
                        <td>{{ item.created_by_name }}</td>
                      </tr>
                      <tr>
                        <th>Дата создания:</th>
                        <td>{{ item.date_created }}</td>
                      </tr>
                      <tr>
                        <th>Изменен:</th>
                        <td>{{ item.modified_by_name || '---' }}</td>
                      </tr>
                      <tr>
                        <th>Дата изменения:</th>
                        <td>{{ item.date_modified || '---' }}</td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </StaticTabs>
    </v-col>

    <v-col :cols="colsBar">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <PayOrderFilter
          class="user-filter"
          :query="initialQuery"
          :count="count"
          :filterPending="filterPending"
          :countTotal="countTotal"
          @filteredLoad="filteredLoadCollbar"
          :acl="acl"
        />

      </v-row>
      <hr />
      <CollectionBar
        :id="item.id"
        :items="coll"
        :count="count"
        :loading="loadingCollbar"
        :scrollBusy="scrollBusy"
        @loadCollbar="loadCollbar"
        @toEdit="toEdit"
        @toView="toView"
      />
    </v-col>

  </v-row>
  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
</div>
</template>

<script>
import { get, edit, PREFIX } from '@/api'
import PayOrderFilter from '@/components/filters/PayOrderFilter'
import ViewMixin from '@/views/View.vue'
import TaskMixin from '@/views/Task.vue'
import MediaList from '@/components/MediaList'
import Comments from '@/components/Comments'
import Status from '@/components/Status'
import NeedWatch from '@/components/NeedWatch'
import NewWatchers from '@/components/NewWatchers'
import NewAssigned from '@/components/NewAssigned'
import NewPriority from '@/components/NewPriority'
import NewDateEnd from '@/components/NewDateEnd'
import NewAccountants from '@/components/NewAccountants'
import WarehouseBalanceTable from '@/components/inventory/WarehouseBalanceTable'

export default {
  mixins: [ViewMixin, TaskMixin],
  components: {
    PayOrderFilter,
    Comments,
    MediaList,
    Status,
    NeedWatch,
    NewWatchers,
    NewAssigned,
    NewAccountants,
    NewPriority,
    NewDateEnd,
    WarehouseBalanceTable
  },
  computed: {
  },
  data: function () {
    return {
      // default filter
      initialQuery: {
      },

      modelName: 'PayOrder',
      viewName: 'payorder',
      viewTitle: 'Фин. задачи',
      parentHref: '#/payorder',

      urlObj: 'payorder/',
      urlList: 'payorders/',

      // item
      item: {
        id: this.id,
        name: '',
        available_statuses: [{ name: '', value: null }],
        check_this_persons: {}
      },
      // collbar
      collbar: {
        url: 'payorders/',
        name: 'payorder'
      },
      // pending
      pendingStatus: false,
      // error
      statusError: ''
    }
  },
  methods: {
    setCheckThisOut (data) {
      this.item.check_this_persons = data
    }
  },
}
</script>
<style scoped>
.task-text {
  color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
}
</style>
